const formatNetRunRate = (value) => {
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return '0.000';
  return numeric.toFixed(3);
};

const getNetRunRateClass = (value) => {
  const numeric = Number(value);
  if (Number.isNaN(numeric) || numeric === 0) return 'nrr-neu';
  return numeric > 0 ? 'nrr-pos' : 'nrr-neg';
};

const TournamentLeaderboardTable = ({ leaderboard = [] }) => {
  if (!leaderboard.length) {
    return (
      <div className="alert alert-info mb-0" role="alert">
        No completed matches yet. Leaderboard standings will appear once matches finish.
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-hover align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Team</th>
            <th scope="col" className="text-center">
              M
            </th>
            <th scope="col" className="text-center">
              W
            </th>
            <th scope="col" className="text-center">
              L
            </th>
            <th scope="col" className="text-center">
              T
            </th>
            <th scope="col" className="text-center">
              NR
            </th>
            <th scope="col" className="text-center">
              Pts
            </th>
            <th scope="col" className="text-center">
              NRR
            </th>
          </tr>
        </thead>
        <tbody>
          {leaderboard.map((entry, index) => (
            <tr key={entry.team}>
              <th scope="row" className="number-decor">{index + 1}</th>
              <td className="fw-semibold">{entry.team}</td>
              <td className="text-center">{entry.matchesPlayed}</td>
              <td className="text-center">{entry.wins}</td>
              <td className="text-center">{entry.losses}</td>
              <td className="text-center">{entry.ties}</td>
              <td className="text-center">{entry.noResult}</td>
              <td className="text-center">{entry.points}</td>
              <td className="text-center">
                <span className={`text-center nrr ${getNetRunRateClass(entry.netRunRate)}`}>{formatNetRunRate(entry.netRunRate)}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TournamentLeaderboardTable;
